<div class="modal-header align-items-center">
  <h2 class="modal-title" translate>lblAddDealer</h2>
  <div class="col-auto ml-auto pr-0">
    <ul class="list-inline d-flex">
      <li>
        <button type="button" class="close btn btn-ico" aria-label="Close" (click)="OnClose(false)"
          ngbTooltip="{{ 'lblClose' | translate }}">
          <span aria-hidden="true">×</span>
        </button>
      </li>
    </ul>
  </div>
</div>
<div class="modal-body p-0">
  <div class="pad5">
    <div class="card">
      <div class="pad5 min-h250">
        <div class="table-responsive max-vh20 p-0 border">
          <table class="tablest1 fixed-header">
            <thead>
              <tr>
                <th translate>lblSelect</th>
                <th translate>lblDealerName</th>
                <th translate>lblAddress</th>
                <th translate>lblEmail</th>
                <th translate>lblMobile</th>
              </tr>
            </thead>
            <tbody class="main-panel">
              <ng-container *ngIf="lstDealers?.length > 0; else load_else_calls">
                <tr *ngFor="let d of lstDealers">
                  <td class="nowrap text-center vertical-middle">
                    <input name="DealerSelect" type="radio" class="radio-custom"
                        (change)="OnDealerSelect(d)" [value]="d.dealerDMSNo"
                        [checked]="selectedDealer && selectedDealer?.dealerDMSNo == d.dealerDMSNo"
                        [disabled]="d.isExists"
                        [ngStyle]="{'background-color': d.isExists ? '#d3d3d3' :  null }" />
                  </td>
                  <td>{{ d.name }}</td>
                  <td>{{ d.address }}</td>
                  <td>{{ d.email }}</td>
                  <td>{{ d.countryCode }} {{ d.phoneNo }}</td>
                </tr>
              </ng-container>
              <ng-template #load_else_calls>
                <tr>
                  <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-primary mr-sm-2 mb-1" type="button" aria-label="Center Align"
      (click)="OnClose(true)" translate [disabled]="!selectedDealer">
      lblSelect
  </button>
  <button class="btn btn-secondary mr-sm-2 mb-1" type="button" aria-label="Center Align"
      (click)="OnClose(false)" translate>
      lblClose
  </button>
</div>